// extracted by mini-css-extract-plugin
module.exports = {"projectStyles":"styles_projectStyles__1L086","contentStyles":"styles_contentStyles__df6a_","title":"styles_title__2PUuo","video":"styles_video__3H2xX"};